import { BaseResponse } from 'common/types/api'
import axios from 'core/api'

import {
  IotDeviceNotificationSettingResponse,
  NotificationCountResponse,
  NotificationResponse,
  NotificationSettingResponse,
} from './types'

export const getNotificationUnreadCount = () =>
  axios.get<BaseResponse<NotificationCountResponse>>('/notifications/unread/count')

export const getNotifications = (params?: Record<string, any>) =>
  axios.get<NotificationResponse>('/notifications', { params })

export const markNotificationAsRead = (ids: string[]) =>
  axios.patch<BaseResponse<void>>(`/notifications/read`, { ids })

export const deleteNotificationAll = (id?: string | number) =>
  axios.delete<BaseResponse<void>>(`/notifications`, { params: { id } })

export const getNotificationsSettingAll = (params?: Record<string, any>) =>
  axios.get<NotificationSettingResponse>('/notification-setting/modules', { params })

export const getNotificationsSettingByModule = (
  moduleCode?: string,
  params?: Record<string, any>
) =>
  axios.get<NotificationSettingResponse>(`/notification-setting/modules/${moduleCode}`, { params })

export const updateNotificationSettingThreshold = (id: string, payload?: Record<string, any>) =>
  axios.patch<BaseResponse<void>>(`/notification-setting/${id}/thresholds`, payload)

export const updateNotificationSettingProfile = (id: string, payload?: Record<string, any>) =>
  axios.patch<BaseResponse<void>>(`/notification-setting/${id}/users/profile`, payload)

// DOF-1309: สวิตช์เปิด-ปิดการแจ้งเตือนของอุปกรณ์ IoT รายคน (ดู types.ts)
export const getIotDeviceNotificationSetting = (deviceId: string) =>
  axios.get<IotDeviceNotificationSettingResponse>(`/notification-setting/iot-devices/${deviceId}`)

export const updateIotDeviceNotificationSetting = (deviceId: string, isEnabled: boolean) =>
  axios.patch<IotDeviceNotificationSettingResponse>(
    `/notification-setting/iot-devices/${deviceId}`,
    { is_enabled: isEnabled }
  )
